import React from 'react';

const containerStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: '#f2f2f2',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999
};

const contentStyle: React.CSSProperties = {
  textAlign: 'center',
  width: '50%'
};

const logoStyle: React.CSSProperties = {
  display: 'block',
  marginBottom: '30px',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '100%'
};

const progressBarContainerStyle: React.CSSProperties = {
  width: '100%',
  height: '4px',
  backgroundColor: 'rgba(33, 150, 243, 0.25)',
  borderRadius: '2px',
  overflow: 'hidden'
};

const progressBarStyle: React.CSSProperties = {
  height: '100%',
  backgroundColor: '#2196f3',
  animation: 'progressBarAnimation 1.5s ease-in-out infinite',
  width: '30%'
};

export function AuthLoadingScreen() {
  return (
    <div style={containerStyle}>
      <style>
        {`
          @keyframes progressBarAnimation {
            0% { width: 0%; margin-left: 0%; }
            50% { width: 100%; margin-left: 0%; }
            100% { width: 0%; margin-left: 100%; }
          }
        `}
      </style>
      <div style={contentStyle}>
        <img
          className="Uhc-logo"
          src="/uhc-brandmark.png"
          alt="UHC Logo"
          style={logoStyle}
        />
        <div style={progressBarContainerStyle}>
          <div style={progressBarStyle} />
        </div>
      </div>
    </div>
  );
}
